import styled from 'styled-components';
import theme from '../../../constants/theme';
import { Columns } from '../../base/grid/grid';
import { tableDataStyles, tableHeaderStyles, tableRowStyles } from '../../base/table/table';

//stylings
export const InfoField = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 2rem;

	svg {
		margin-right: 1rem;
	}
`;

export const Wrapper = styled.div`
	margin-top: 4rem;
	table {
		height: auto !important;
		width: 100% !important;
		max-width: 100vw;
		overflow-x: auto;

		a {
			padding: 0;
			margin: 0;
		}

		svg {
			width: auto;
			height: 1.75rem;
		}

		& td:last-child {
			text-align: right;
			svg {
				cursor: pointer;
			}
			svg:first-child {
				margin-right: 1rem;
			}
			width: 9rem;
		}
	}

	tr {
		${tableRowStyles};
	}

	th {
		${tableHeaderStyles};
	}

	th,
	td {
		${tableDataStyles};
		padding-left: 1.5rem;
	}

	.center {
		display: grid;
		place-items: center;
	}
`;

export const StyledColumns = styled(Columns)`
	margin: 4rem;

		svg {
			width: auto;
			height: 3rem;
			fill: ${theme.colors.primary};
			margin-right: 1rem;
			margin-bottom: -1rem;
		}
	}
	div:last-child {
		> nav {
			justify-content: flex-end;
		}
	}
`;

export const StyledErrorMessage = styled.div`
	margin-top: 1rem;
	color: ${theme.colors.primary};
	text-transform: uppercase;
`;

export const StyledSpan = styled.span`
	color: ${theme.colors.primary};
	text-transform: uppercase;
	font-weight: bold;
`;

export const StyledMessage = styled.div`
	margin: 3rem;
	color: ${theme.colors.grayDarker};
`;
